/* eslint-disable radix */
import React, { useRef } from 'react';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';

import useScreenSize from '../hooks/useScreenSize';

import styles from '../styles/carousel.module.scss';

const CardCarousel = ({
  title,
  children,
}) => {

  const screenSize = useScreenSize()

  const containerRef = useRef(null);

  const getCarouselRotationCount = () => {
    const rotationCountMapping = {
      large: 4,
      medium: 3,
      small: 2,
      xsmall: 1,
    };

    return rotationCountMapping[screenSize] ?? 4;
  };

  const scrollLiveVideoCarousel = (position) => {
    const container = containerRef.current;

    if (!container) return;

    const cardElement = container.firstChild;
    const cardWidth = cardElement.clientWidth + parseInt(getComputedStyle(cardElement).marginRight);
    const rotationCount = getCarouselRotationCount() ?? 4;

    const calculation = position === 'left' ? container.scrollLeft - cardWidth * rotationCount : container.scrollLeft + cardWidth * rotationCount;

    container.scrollLeft = calculation;
  }; 

  const shouldDisplayScrollButtons = () => {
    const rotationCount = getCarouselRotationCount();

    if (children.length <= rotationCount) return false;

    return true;
  };

  const renderScrollButton = (position, className = '') => (
    <Button
      className={className}
      icon={position === 'left' ? <KeyboardArrowLeft sx={{ height: 40, width: 40 }} /> : <KeyboardArrowRight sx={{ height: 40, width: 40 }} />}
      onClick={() => scrollLiveVideoCarousel(position)}
      variant="ghost"
    />
  );

  return (
    <>
      <div className={styles.header}>
        {title && (
          <Typo className={styles.title} element="h4" variant="h4" modifier="bold">
            {title}
          </Typo>
        )}
        {shouldDisplayScrollButtons() && (screenSize === 'small' || screenSize === 'medium' || screenSize === 'xsmall')
          && (
          <div className={styles.header_actions}>
            {renderScrollButton('left')}
            {renderScrollButton('right')}
          </div>
          )}
      </div>
      <div className={styles.content_container}>
        {shouldDisplayScrollButtons() && (screenSize === 'large' || screenSize === 'xlarge') && renderScrollButton('left', styles.content_actions_left)}
        <div className={styles.content} id="scroll-container" ref={containerRef}>
          {children}
        </div>
        {shouldDisplayScrollButtons() && (screenSize === 'large' || screenSize === 'xlarge') && renderScrollButton('right', styles.content_actions_right)}
      </div>
    </>
  );
};

CardCarousel.propTypes = {};

export default React.memo(CardCarousel);
